import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/GasDataProvider";
import CalculatorMessage from "../../../../shared/CalculatorMessage";
import Campaign from "../../../../shared/Campaign";
import * as styles from "./style.module.scss";

const GasMessage = () => {
    const dataContext = useContext(DataContext);
    const { result, zipcodeIsValid, consumptionIsValid } = dataContext.data;

    return (
        <>
            {zipcodeIsValid &&
                consumptionIsValid &&
                result &&
                !result.saveBaseProvider.match(/-/) && (
                    <CalculatorMessage>
                        <Campaign name="mitmachen2020">
                            <Campaign.Content>
                                <div className={styles.save}>
                                    <span style={{ fontWeight: "bold" }}>
                                        {" "}
                                        100 €.{" "}
                                    </span>
                                    <span style={{ fontWeight: "normal" }}>
                                        Jetzt noch schnell mitnehmen! Strom und
                                        Erdgas bis zum{" "}
                                    </span>
                                    <span style={{ color: "red" }}>
                                        31.12.2020{" "}
                                    </span>
                                    <span>wechseln.</span>
                                </div>
                            </Campaign.Content>
                            <Campaign.Fallback>
                                <div className={styles.label}>
                                    Grundversorger:
                                </div>
                                <div className={styles.name}>
                                    {result.baseProviderName}
                                </div>
                                <div className={styles.save}>
                                    Ersparnis bis zu: {result.saveBaseProvider}
                                    &nbsp;&euro;
                                </div>
                            </Campaign.Fallback>
                        </Campaign>
                    </CalculatorMessage>
                )}
        </>
    );
};

export default GasMessage;
